
import { NoiseSuppressionEffect } from '../../stream-effects/noise-suppression/NoiseSuppressionEffect';
import { createScreenshotCaptureEffect } from '../../stream-effects/screenshot-capture';
import { createVirtualBackgroundEffect } from '../../stream-effects/virtual-background';
import { getVirtualBackgroundOptions } from '../../virtual-background/reducer';

import logger from './logger';

/**
 * Loads the enabled stream effects.
 *
 * @param {Object} store - The Redux store.
 * @returns {Promise} - A Promise which resolves when all effects are created.
 */
export default async function loadEffectsForPreview(store: Object) {
    const start = window.performance.now();
    const state = store.getState();

    // Get virtual background options from Redux store
    const virtualBackground = getVirtualBackgroundOptions(state);

    const noiseSuppression = state['features/noise-suppression'];
    const { noiseSuppression: nsOptions } = state['features/base/config'];

    const backgroundPromise = virtualBackground?.backgroundEffectEnabled
        ? createVirtualBackgroundEffect(virtualBackground)
            .catch(error => {
                logger.error('Failed to obtain the background effect instance with error: ', error);

                return Promise.resolve();
            })
        : Promise.resolve();

    const noiseSuppressionPromise = noiseSuppression?.enabled
        ? Promise.resolve(new NoiseSuppressionEffect(nsOptions))
        : Promise.resolve();

    const screenshotCapturePromise = state['features/screenshot-capture']?.capturesEnabled
        ? createScreenshotCaptureEffect(state)
            .catch(error => {
                logger.error('Failed to obtain the screenshot capture effect effect instance with error: ', error);

                return Promise.resolve();
            })
        : Promise.resolve();

    const effectsArray = await Promise.all([ backgroundPromise, noiseSuppressionPromise, screenshotCapturePromise ]);
    const end = window.performance.now();

    logger.debug(`(TIME) loadEffects() start=${start}, end=${end}, time=${end - start}`);

    return effectsArray;
}
